import axios from "@/api/axiosInstance";

export function fetchReferrals(pageNumber) {
  return axios.get(`/api/v1/referrals/userReferrals?page=${pageNumber}`);
}
export function fetchSortReferrals(payload) {
  return axios.get(
    `/api/v1/referrals/userReferral?level=${payload.level}&page=${payload.pageNumber}`
  );
}
